module.exports = __webpack_public_path__ + "static/media/top.6ae37d70.svg";